import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.Title',
    defaultMessage: 'Waitlist',
  },
  affordablePrograms: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.AffordablePrograms',
    defaultMessage: 'Affordable Programs',
  },
  affordableProgramsTooltip: {
    // eslint-disable-next-line max-len
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.AffordableProgramsTooltip',
    defaultMessage:
      'Select the Affordable programs that apply to this waitlist. ' +
      'Options are limited to programs configured on this property.',
  },
  enableWaitlist: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.EnableWaitlist',
    defaultMessage: 'Enable Waitlist?',
  },
  enableWaitlistTooltip: {
    // eslint-disable-next-line max-len
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.EnableWaitlistTooltip',
    defaultMessage:
      'Enables waitlist functionality for this property. When turned off, ' +
      'all waitlist settings are hidden and the waitlist is inactive.',
  },
  openWaitlist: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.OpenWaitlist',
    defaultMessage: 'Open Waitlist?',
  },
  separateWaitlist: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.SeparateWaitlist',
    defaultMessage: 'Separate waitlist by bedroom',
  },
  openDate: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.OpenDate',
    defaultMessage: 'Open Date',
  },
  openDateRequired: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.OpenDateRequired',
    defaultMessage: 'Open date is required when the waitlist is open.',
  },
  usePreferences: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.UsePreferences',
    defaultMessage: 'Use preferences for ranking?',
  },
  usePreferencesTooltip: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.UsePreferencesTooltip',
    defaultMessage:
      'Determines whether applicant ranking is based on preference weights.',
  },
  closeDate: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.CloseDate',
    defaultMessage: 'Close Date',
  },
  preferenceWeight: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferenceWeight',
    defaultMessage: 'Preference weight for ranking method',
  },
  preferencesRankingMethod: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesRankingMethod',
    defaultMessage: 'Preferences Ranking Method',
  },
  preferencesRankingMethodTooltip: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesRankingMethodTooltip',
    defaultMessage:
      'Select how preference weights are evaluated when ranking applicants on the waitlist.',
  },
  totalPoints: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.TotalPoints',
    defaultMessage: 'Total Points',
  },
  highestPreferenceWeight: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.HighestPreferenceWeight',
    defaultMessage: 'Highest Preference Weight',
  },
  configurePreferencesTitle: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.ConfigurePreferencesTitle',
    defaultMessage: 'Configure Preferences',
  },
  preferencesSection: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection',
    defaultMessage: 'Preferences',
  },
  rankingWeightSection: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesRankingSection',
    defaultMessage: 'Ranking Weight',
  },
  veteran: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.Veteran',
    defaultMessage:
      'Veteran or the unmarried spouse of a service person killed while in active service',
  },
  fosterCare: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.FosterCare',
    defaultMessage: 'Young adult transitioning out of foster care',
  },
  involuntarilyDisplaced: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.InvoluntarilyDisplaced',
    defaultMessage: 'Being involuntarily displaced',
  },
  disability: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.Disability',
    defaultMessage: 'Disability',
  },
  elderly: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.Elderly',
    defaultMessage: 'Elderly',
  },
  homeless: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.Homeless',
    defaultMessage: 'Homeless',
  },
  rentBurden: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.RentBurden',
    defaultMessage: 'Paying more than 50% of your income for rent',
  },
  residency: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.Residency',
    defaultMessage: 'Residency',
  },
  victim: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.Victim',
    defaultMessage: 'Victim',
  },
  workingFamilies: {
    id: 'App.ViewProperty.AffordableSetup.WaitlistV2.PreferencesSection.WorkingFamilies',
    defaultMessage: 'Working families',
  },
});

export default messages;
